<template>
    <filters-wrapper :has-active-filters="hasActiveFilters" @submit="emit('submit')" @reset="emit('reset')">
        <template v-slot:panel>
            <FilterStatusToggle v-model="filters.active" @update:model-value="emit('submit')" />
        </template>
        <v-form class="table-filters mb-4">
            <v-row dense>
                <v-col cols="12" sm="6" md="3">
                    <v-text-field v-model="filters.nameFilter" :label="$t('name')" hide-details />
                </v-col>
            </v-row>
        </v-form>
    </filters-wrapper>
</template>

<script setup lang="ts">
    defineProps<{
        hasActiveFilters: boolean
    }>()

    const filters = defineModel<any>()
    const emit = defineEmits<{
        (e: 'submit' | 'reset'): void
    }>()
</script>
